import { render, staticRenderFns } from "./BannerOffers.vue?vue&type=template&id=003618da&"
import script from "./BannerOffers.vue?vue&type=script&lang=js&"
export * from "./BannerOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports